import Vue from 'vue';
import linkDynamic from '@editor/droplets/_bubble-options/components/link-dynamic';

export default Vue.component('edit-place-details', {
  template: require('./template.html'),
  name: 'edit-place-details',
  props: ['droplet', 'show-edit-bubble', 'dynamic-item'],
  components: {
    linkDynamic,
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/place-details/components/_edit-options/index.js